export default __webpack_public_path__ + "static/media/Employee-Management-System-img-3.594033d6.gif";